import { useState } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo_big.png";
import "./admin.css";

const navItems = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
  },
  {
    path: "/admin/members",
    label: "Members",
  },
  {
    path: "/admin/reservations",
    label: "Reservations",
  },
  {
    path: "/admin/careers",
    label: "Careers",
  },
];

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("hobAdminToken");
    navigate("/admin");
  };

  const pageTitle =
    navItems.find((n) => n.path === location.pathname)?.label || "Admin";

  return (
    <div className="hobadmin-layout">
      {/* Sidebar */}
      <aside
        className={`hobadmin-sidebar ${
          sidebarOpen ? "hobadmin-sidebar-open" : "hobadmin-sidebar-closed"
        }`}
      >
        {/* Header */}
        <div className="hobadmin-sidebar-header">
          {sidebarOpen && (
            <img src={logo} alt="Logo" className="hobadmin-logo" />
          )}

          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="hobadmin-toggle-btn"
            aria-label="Toggle Sidebar"
          >
            ☰
          </button>
        </div>

        {/* Admin Badge */}
        {sidebarOpen && (
          <div className="hobadmin-badge-wrap">
            <span className="hobadmin-badge">Admin Panel</span>
          </div>
        )}

        {/* Navigation */}
        <nav className="hobadmin-nav">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                title={!sidebarOpen ? item.label : ""}
                className={`hobadmin-nav-item ${
                  isActive ? "hobadmin-nav-active" : "hobadmin-nav-default"
                }`}
              >
                {sidebarOpen && (
                  <span className="hobadmin-nav-text">{item.label}</span>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="hobadmin-logout-wrap">
          <button onClick={handleLogout} className="hobadmin-logout-btn">
            <span>↩</span>

            {sidebarOpen && (
              <span className="hobadmin-logout-text">Logout</span>
            )}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="hobadmin-content">
        {/* Top Header */}
        <header className="hobadmin-header">
          <div>
            <h1 className="hobadmin-page-title">{pageTitle}</h1>

            <p className="hobadmin-page-subtitle">
              House of Bombay Content Management
            </p>
          </div>

          <div className="hobadmin-user">
            <div className="hobadmin-avatar">A</div>

            <span className="hobadmin-user-name">Admin</span>
          </div>
        </header>

        {/* Page Content */}
        <main className="hobadmin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
